// DATOS DE EJEMPLO — mockup del dashboard v1; reemplazar cuando se definan los indicadores reales.
// Ninguna grafica del inicio conecta datos reales: el unico dato vivo del dashboard
// es el contador de tareas pendientes, que se resuelve en HomePage con la query real.
import type { MobileIconName } from '@/components/MobileIcon';

/** Colores de datos para los SVG: solo tokens existentes (primary, accent, success). */
export const chartColors = {
  primary: 'var(--color-primary)',
  accent: 'var(--color-accent)',
  success: 'var(--color-success)',
} as const;

export type DashboardTrend = {
  direction: 'up' | 'down';
  value: number;
};

export type DashboardKpi = {
  key: string;
  label: string;
  value: string | number;
  trend?: DashboardTrend;
  icon: MobileIconName;
};

export type PipelineStep = {
  label: string;
  percent: number;
  /** El token accent (lima) es solo decorativo/datos; el resto usa primary. */
  tone?: 'primary' | 'accent';
};

export type WeeklyBarsMock = {
  title: string;
  legend: Array<{ label: string; color: string }>;
  series: Array<{ label: string; primary: number; accent: number }>;
};

export type DonutMock = {
  title: string;
  centerValue: string;
  segments: Array<{ label: string; value: number; color: string }>;
};

export type TopClient = {
  name: string;
  initials: string;
  value: string;
  delta?: number;
};

export const kpis: DashboardKpi[] = [
  {
    key: 'quotations-active',
    label: 'Cotizaciones activas',
    value: 18,
    trend: { direction: 'up', value: 12 },
    icon: 'request_quote',
  },
  {
    key: 'budgets-in-progress',
    label: 'Presupuestos en curso',
    value: 7,
    trend: { direction: 'down', value: 4 },
    icon: 'calculate',
  },
  {
    key: 'month-sales',
    label: 'Ventas del mes (S/.)',
    value: 'S/ 48,250',
    trend: { direction: 'up', value: 18 },
    icon: 'payments',
  },
];

export const pipeline: PipelineStep[] = [
  { label: 'Requerimientos registrados', percent: 82 },
  { label: 'Cotizaciones enviadas', percent: 64, tone: 'accent' },
  { label: 'Presupuestos aprobados', percent: 41 },
];

export const weeklyBars: WeeklyBarsMock = {
  title: 'Ventas de la semana',
  legend: [
    { label: 'Ventas', color: chartColors.primary },
    { label: 'Cotizaciones', color: chartColors.accent },
  ],
  series: [
    { label: 'Lun', primary: 8, accent: 5 },
    { label: 'Mar', primary: 12, accent: 7 },
    { label: 'Mié', primary: 9, accent: 6 },
    { label: 'Jue', primary: 14, accent: 9 },
    { label: 'Vie', primary: 16, accent: 11 },
    { label: 'Sáb', primary: 10, accent: 6 },
    { label: 'Dom', primary: 5, accent: 3 },
  ],
};

export const donut: DonutMock = {
  title: 'Estado de cotizaciones',
  centerValue: '24',
  segments: [
    { label: 'Aprobadas', value: 9, color: chartColors.success },
    { label: 'Enviadas', value: 8, color: chartColors.primary },
    { label: 'En borrador', value: 7, color: chartColors.accent },
  ],
};

export const topClients: TopClient[] = [
  { name: 'Constructora Andina SAC', initials: 'CS', value: 'S/ 24,500', delta: 9 },
  { name: 'Ferretería El Tornillo', initials: 'FT', value: 'S/ 18,300', delta: -3 },
  { name: 'Inversiones del Norte', initials: 'IN', value: 'S/ 12,750' },
];
